import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { ContribType, ContributionName, ComponentDivider } from "../styles";

export const MultiLots = (props) => {
    const { securityName, ticker, shares, salePrice, saleFee, processingFee, netProceeds, saleDate, settlementDate } = props.lotDetails;
    return (
        <>
        <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Security Name</ContribType>
                  <ContributionName>
                    {securityName ? securityName : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Security Ticker</ContribType>
                  <ContributionName >
                    {ticker ? ticker : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px" />
            </Col>
          </Row>
          <Row>

          <Col lg={{ span: 12 }} md={{ span: 12 }}>
            <Row>
              <>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Number of shares</ContribType>
                <ContributionName >
                {shares ? shares : <div>&mdash;</div>}
                </ContributionName>
              </Col>
              </>
            </Row>
            <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px" />
          </Col>
        </Row>
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Sale Price</ContribType>
                  <ContributionName>
                  { salePrice ? salePrice : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Sales Fee</ContribType>
                  <ContributionName>
                  { saleFee ? saleFee : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            </Col>
          </Row>
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Processing Fee</ContribType>
                  <ContributionName>
                  { processingFee ? processingFee : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Net Proceeds</ContribType>
                  <ContributionName>
                  { netProceeds ? netProceeds : <div>&mdash;</div>}
                  </ContributionName>
                </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            </Col>
          </Row>
          <Row>
            <Col lg={{ span: 12 }} md={{ span: 12 }}>
              <Row>
              <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                  <ContribType>Sale Date</ContribType>
                  <ContributionName>
                  {saleDate ? saleDate : <div>&mdash;</div> }
                  </ContributionName>
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} xs={12}>
                <ContribType>Settlement Date</ContribType>
                <ContributionName>
                  { settlementDate ? settlementDate : <div>&mdash;</div>}
                </ContributionName>
              </Col>
              </Row>
              <ComponentDivider top='20px' bottom="20px" mobileTop='10px' mobileBottom="10px"  />
            </Col>
          </Row>
        </>
    );
};

MultiLots.propTypes = {
  lotDetails: PropTypes.object
}

export default MultiLots;